import { RouterProvider } from 'react-router';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { ConfirmProvider, MotionProvider, Toaster, useIsDesktop } from '@dezza/ui';
import { persister, PERSIST_MAX_AGE, queryClient } from '../lib/query';
import { AuthProvider } from '../lib/auth';
import { router } from './router';

export function App() {
  const isDesktop = useIsDesktop();
  return (
    <MotionProvider>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister,
          maxAge: PERSIST_MAX_AGE,
          buster: 'v1',
          dehydrateOptions: {
            // Só dados reais: nunca persistir "sessão vazia" (senão o app abriria deslogado).
            shouldDehydrateQuery: (q) =>
              q.meta?.persist === true && q.state.status === 'success' && q.state.data != null,
          },
        }}
      >
        <AuthProvider>
          <ConfirmProvider>
            <RouterProvider router={router} />
            {/* No topo: nunca cobre os botões principais das barras flutuantes do rodapé. */}
            <Toaster position={isDesktop ? 'top-right' : 'top-center'} />
          </ConfirmProvider>
        </AuthProvider>
      </PersistQueryClientProvider>
    </MotionProvider>
  );
}
